/** CSS variables to be used sparingly to override the font sizes where necessary. Primarily used to support requirements of the logged-out experience. */
export var fontOverrides = {
    buttonMedium: '--wf-button--medium',
    displayLarge: '--wf-display--large',
    displayMedium: '--wf-display--medium',
    displaySmall: '--wf-display--small',
    displayXLarge: '--wf-display--xlarge',
    displayXXLarge: '--wf-display--xxlarge',
};
